import React from 'react'
import { makeStyles, CircularProgress } from '@material-ui/core'
import clsx from 'clsx'

const useStyles = makeStyles((theme) => ({
  progress: {
    color: theme.palette.disable.default,
  },
}))
export const ProgressWithText = ({ label, isDisable }) => {
  const classes = useStyles()
  const getProgressStyle = () => {
    if (isDisable === true) return classes.progress
    else return null
  }
  return (
    <div className="flex flex-row">
      {label}
      <CircularProgress
        size={16}
        className={clsx('ltr:ml-12 rtl:mr-12', getProgressStyle())}
      />
    </div>
  )
}
